import { UAParser } from 'ua-parser-js';

const LEGACY_IPAD_APP_USER_AGENT =
  'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko)';
const LEGACY_IPHONE_APP_USER_AGENT =
  'Mozilla/5.0 (iPhone; CPU iPhone OS 15_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148';

export function isIOS() {
  const parser = new UAParser();

  const ua = parser.getUA();
  if (ua === LEGACY_IPAD_APP_USER_AGENT || ua === LEGACY_IPHONE_APP_USER_AGENT) {
    return true;
  }

  const browserName = parser.getBrowser().name;
  const os = parser.getOS().name;

  let shouldNativeControlBrowserName = ['Safari', 'Mobile Safari'];
  if (os === 'iOS') {
    shouldNativeControlBrowserName = [...shouldNativeControlBrowserName, 'Chrome', 'Chrome WebView'];
  }
  return shouldNativeControlBrowserName.includes(browserName || '');
}

export function isAndroid() {
  const parser = new UAParser();

  const os = parser.getOS().name;

  return os === 'Android';
}

export function isMac() {
  const parser = new UAParser();
  const os = parser.getOS().name;
  return os === 'macOS';
}
